import 'regenerator-runtime/runtime';
import { getFeature, Features } from './PermissionUtility';
import { showMessage, updateMessage, closeMessage } from './MessageUtility';
import { throttle } from './utility';
import { Logout } from '../auth/AuthService';

export const iatLastActiveTimeKey = 'iat.lastactivetime';
export const iatTimeoutKey = 'iat.timeout';
const warningPeriod = 60;
const warningPeriodInMs = warningPeriod * 1000;
let showedWarning = false;
let showedTimeout = false;
let timeout = null;
const timeoutCallbacks = [];
const inactivityTimeoutEvents = [];

function innerSetLastActiveTime() {
  localStorage.setItem(iatLastActiveTimeKey, String(new Date().getTime()));
}

const setLastActiveTime = throttle(() => {
  if (!showedWarning && !showedTimeout) {
    innerSetLastActiveTime();
  }
}, 1000);

function executeTimeoutCallbacks() {
  if (timeoutCallbacks && timeoutCallbacks.length > 0) {
    for (let i = 0; i < timeoutCallbacks.length; i++) {
      //need to execute any ajax callbacks that got blocked by timeout
      if (timeoutCallbacks[i] && typeof timeoutCallbacks[i] === 'function') {
        timeoutCallbacks[i]();
      }
    }
  }
}

let warningMessageUpdateInterval = null;
let warningMessageId = null;

function hideWarning(shouldCloseMessage) {
  showedWarning = false;
  if (warningMessageUpdateInterval) {
    clearInterval(warningMessageUpdateInterval);
  }
  if (shouldCloseMessage) {
    closeMessage(warningMessageId);
  }
}

function showWarning() {
  if (showedWarning) {
    return;
  }
  showedWarning = true;

  warningMessageId = showMessage(
    'Session Expiring Soon',
    `For account security, you’ll be logged out in ${warningPeriod} seconds`,
    (didConfirm) => {
      if (didConfirm) {
        innerSetLastActiveTime();
        hideWarning(false);
      }
    },
    'Keep working'
  );

  for (const inactivityTimeoutEvent of inactivityTimeoutEvents) {
    inactivityTimeoutEvent();
  }

  let i = 0;
  warningMessageUpdateInterval = setInterval(() => {
    i += 1;

    updateMessage(warningMessageId, `For account security, you’ll be logged out in ${warningPeriod - i} second${warningPeriod - i > 1 ? 's' : ''}`);

    if (i === warningPeriod - 1 && warningMessageUpdateInterval) {
      clearInterval(warningMessageUpdateInterval);
    }
  }, 1000);
}

function doCheck() {
  const currentInactiveTime = getCurrentInactiveTime();
  if (currentInactiveTime > timeout - warningPeriodInMs) {
    //sometimes we can show the timeout box before the warning if the server timed us out
    if (!showedWarning && !showedTimeout) {
      showWarning();
    }
    if (currentInactiveTime > timeout) {
      if (!showedTimeout) {
        showedTimeout = true;
        hideWarning(true);
        Logout();
      }
    }
  } else {
    if (showedWarning) {
      hideWarning(true);
    }

    executeTimeoutCallbacks();
  }
}

let initialized = false;

function getCurrentInactiveTime() {
  const lat = Number(localStorage.getItem(iatLastActiveTimeKey));
  const now = new Date().getTime();
  return now - lat;
}

// This should only be called after we've loaded the client features
export function initInactivityTimeout() {
  if (initialized) {
    return;
  }

  timeout = getFeature(Features.InactivityTimeout);
  timeout *= 1000; //assuming the input is in seconds.  We need ms for our work
  if (!timeout || timeout <= 0) {
    localStorage.setItem(iatTimeoutKey, null);
    return;
  }

  localStorage.setItem(iatTimeoutKey, timeout);
  setLastActiveTime();
  setInterval(doCheck, 500);

  document.addEventListener('keypress', setLastActiveTime);
  document.addEventListener('mousedown', setLastActiveTime);
  document.addEventListener('touchstart', setLastActiveTime);
  document.addEventListener('click', setLastActiveTime);
  document.addEventListener('scroll', setLastActiveTime);
  document.addEventListener('mousemove', setLastActiveTime);

  initialized = true;
}

export function registerInactivityTimeoutEvent(func) {
  inactivityTimeoutEvents.push(func);
}

export function unregisterInactivityTimeoutEvent(func) {
  const index = inactivityTimeoutEvents.findIndex((x) => x === func);
  inactivityTimeoutEvents.splice(index);
}
